/*
 * @Author: linghujie 391103334@qq.com
 * @Date: 2022-10-19 08:43:23
 * @LastEditors: linghujie 391103334@qq.com
 * @LastEditTime: 2023-03-10 09:37:44
 * @FilePath: \shared-mask-machine-website\src\api\api.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import request from './index'

//首页数据
export function postHome() {
    return request({
        url: '/mgl/index',
        method: 'post',
    })
}

//菜单
export function getMenu() {
    return request({
        url: '/mgl/classdata',
        method: 'get',
    })
}
//单一菜单
export function getClass(data) {
    return request({
        url: '/mgl/getclass',
        method: 'get',
        params:data
    })
}
//获取分类信息列表
export function getClassinfo(data) {
    return request({
        url: '/mgl/classinfo',
        method: 'get',
        params:data
    })
}
//获取信息详情
export function getInfo(data) {
    return request({
        url: '/mgl/info',
        method: 'get',
        params:data
    })
}
//服务商查询
export function getAgentInfo(data) {
    return request({
        url: '/nlm/bill/agent',
        method: 'get',
        params:data,
        headers:{
            "tenant-id":1
        }
    })
}
//合作伙伴查询
export function getPrimaryInfo(data) {
    return request({
        url: '/account/agent/primary',
        method: 'get',
        params:data,
        headers:{
            "tenant-id":1
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js